import { routes, subroute } from '../routes/routes.constants';

export const getRoutePath = () => window.location.pathname.replace(routes.getRoot(), '');

export const getClassNameFromRoute = (): string => {
  const routePath = getRoutePath();
  const result = routePath.replace(subroute, '').replace(/[a-z]?[A-Z]|[0-9]|\.|-|\//g, '');

  return result || 'home';
};
